export default "__VITE_ASSET__B$0BO5Fn__"